<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import { useSignalRStore, useUserStore } from '../../stores';
import { UserRole } from '../../types/user';
import StudentView from './StudentView.vue';
import TeacherView from './TeacherView.vue';
import { useEventListener, useIntervalFn, useWakeLock } from '@vueuse/core';
import Disconnected from '../../components/Notification/Disconnected.vue';

const user = useUserStore()
const signalr = useSignalRStore()
const wakeLock = useWakeLock()

function handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
        if (signalr.isConnected) {
            signalr.disconnect()
        }
        return
    }

    if (!signalr.isConnected) {
        signalr.connect()
    }
}

useEventListener(window, 'visibilitychange', handleVisibilityChange)

onMounted(() => {
    signalr.connect()
    signalr.onEventHandler()
    wakeLock.request('screen').catch(error => console.error('WakeLock unavailable:', error))
})

onBeforeUnmount(() => {
    signalr.disconnect()
    signalr.offEventHandler()
    wakeLock.release()
})

useIntervalFn(() => signalr.connect(), 1000)
</script>

<template>
    <TeacherView v-if="user.userRole === UserRole.teacher" />
    <StudentView v-if="user.userRole === UserRole.student" />
    <Disconnected />
</template>